module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-14.0b954422.png";